const ALLOWED_TYPES = ["buyer", "seller", "both"];
const ALLOWED_STATUSES = ["lead", "active", "inactive", "closed"];

/** Last matching value wins — mirrors C1 `query_params.get`. */
function lastAllowed(values, allowed) {
  const matched = (values || []).filter((v) => allowed.includes(v));
  if (matched.length === 0) return "";
  return matched[matched.length - 1];
}

export function readCorporateListQuery(search) {
  const params = new URLSearchParams(search || "");
  const pageRaw = Number.parseInt(params.get("page") || "1", 10);
  const page = Number.isFinite(pageRaw) && pageRaw > 0 ? pageRaw : 1;
  const type = lastAllowed(params.getAll("type"), ALLOWED_TYPES);
  const status = lastAllowed(params.getAll("status"), ALLOWED_STATUSES);
  return {
    query: params.get("q") || "",
    type,
    status,
    page,
  };
}

export function buildCorporateListParams({
  query = "",
  type = "",
  status = "",
  page = 1,
  pageSize = 20,
} = {}) {
  const params = { page, page_size: pageSize };
  const trimmed = String(query || "").trim();
  if (trimmed) params.search = trimmed;
  if (type && ALLOWED_TYPES.includes(type)) params.type = type;
  if (status && ALLOWED_STATUSES.includes(status)) params.status = status;
  return params;
}

export function writeCorporateListSearch({
  query = "",
  type = "",
  status = "",
  page = 1,
} = {}) {
  const params = new URLSearchParams();
  const trimmed = String(query || "").trim();
  if (trimmed) params.set("q", trimmed);
  if (type && ALLOWED_TYPES.includes(type)) params.set("type", type);
  if (status && ALLOWED_STATUSES.includes(status)) {
    params.set("status", status);
  }
  if (page > 1) params.set("page", String(page));
  const qs = params.toString();
  return qs ? `?${qs}` : "";
}
